import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { UploadSimple } from "@phosphor-icons/react";

export const resolveLogoUrl = (url) =>
  url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export const LogoUploader = ({ onUploaded }) => {
  const [busy, setBusy] = useState(false);
  const onPick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) return toast.error("Logo must be under 2 MB");
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/settings/dealership/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.logo_url);
      toast.success("Logo uploaded — it will print on all invoices");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <label
      data-testid="settings-logo-upload"
      className={`inline-flex items-center gap-2 px-3 py-2 border border-ink text-xs font-mono uppercase tracking-wider cursor-pointer hover:bg-ink hover:text-white ${busy ? "opacity-50 pointer-events-none" : ""}`}
    >
      <UploadSimple size={14} weight="bold" />
      {busy ? "Uploading…" : "Upload logo file"}
      <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={onPick} data-testid="settings-logo-file-input" />
    </label>
  );
};
